module.exports = __webpack_public_path__ + "static/img/bronze.8d9472a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/games/leagueoflegends/ranks/bronze.png
// module id = RcUZ
// module chunks = 35